import { brainstormText } from 'content/brainstormText'

import { Conversation } from './types'

export const userMessage = {
	content: '',
	role: 'user',
}

export const updateAIResponse = (content: string) => {
	return {
		content,
		role: 'assistant',
	}
}

export const buildIdeationPayload = (
	prompt: string,
	authorIdeation: string[],
	competitorResponse: string
): string => {
	const sections = [
		{ label: 'Scenario', text: prompt },
		{
			label: brainstormText.battleShips.ideationTitles[0],
			text: authorIdeation[0] ?? '',
		},
		{
			label: brainstormText.battleShips.ideationTitles[1],
			text: competitorResponse,
		},
		{
			label: brainstormText.battleShips.ideationTitles[2],
			text: authorIdeation[1] ?? '',
		},
	]
	let result = ''
	sections.forEach(({ label, text }) => {
		if (text.length > 0) {
			result += result.length > 0 ? '<br>' : ''
			result += `<b><i>${label}</i></b>`
			result += `\n${text}`
		}
	})
	return result
}

export const generateRequest = (
	i: number,
	gameTypeId: number,
	companyName: string,
	topic: string,
	currentPrompt: string,
	responseConversation: Conversation[][],
	currentResponses: string[][]
) => {
	let gameScenario = 'response'
	if (i === 1) gameScenario = 'secondResponse'
	else if (i === 2) gameScenario = 'thirdResponse'

	const req = {
		gameTypeId,
		gameScenario,
		companyName,
		topic,
		companyDisruption: currentPrompt,
		conversation: responseConversation[i] ?? [],
		aiScenarioResponse: '',
	}

	if (i === 2) {
		req.aiScenarioResponse = currentResponses[1]?.join(' ') || ''
	} else {
		req.aiScenarioResponse = ''
	}

	return req
}
